import css from './TextInput.module.css';
import React, { ReactNode } from 'react';

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    inputClassNameWrapper?: string;
    inputClassName?: string;
    iconClassName?: string;
    leftChildren?: ReactNode;
    disabled?: boolean;
    rightChildren?: ReactNode;
}

const TextInput: React.FC<TextInputProps> = ({
    inputClassNameWrapper = css.inputWrapper,
    inputClassName = css.input,
    children,
    disabled = false,
    leftChildren,
    rightChildren,
    ...props
}) => {
    return (
        <div
            className={`${inputClassNameWrapper} ${disabled && css.disabledWrapper}`}
        >
            {leftChildren}
            <input
                type="text"
                className={inputClassName}
                disabled={disabled}
                {...props}
            />
            {rightChildren}
        </div>
    );
};

export default TextInput;
